import React, {useState, useRef, useEffect} from 'react';
import {StyleSheet, Text, Pressable, View} from 'react-native';
import {SessionType} from "../../data/SessionInterface";

const SessionTypeBanner = ({sessionType, updateValue = (field: string, value: SessionType) => {}, isEditing=false, onEditRequest = null}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(sessionType);
    const bannerRef = useRef(null);

    useEffect(() => {
        setSelectedOption(sessionType);
    }, [sessionType]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (bannerRef.current && !bannerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleOptionPress = (option: any) => {
        setSelectedOption(option);
        updateValue('sessionType', option);
        setIsOpen(false);
    };

    const renderOptions = () => {
        const availableOptions = Object.values(SessionType).filter(
            (option) => option !== selectedOption
        );
        return availableOptions.map((option) => (
            <Pressable key={option} style={[styles.banner, getStatusColor(option)]}
                              onPress={() => handleOptionPress(option)}>
                <Text style={styles.bannerText}>{option}</Text>
            </Pressable>
        ));
    };

    const getStatusColor = (sessionType) => {
        switch (sessionType) {
            case 'DAY':
                return {backgroundColor: '#A2D9CE', color: '#1abc9c'};
            case 'HALF-DAY':
                return {backgroundColor: '#D2B4DE', color: '#f39c12'};
            case 'OVERNIGHT':
                return {backgroundColor: '#7FB3D5', color: '#9b59b6'};
            case 'EXTENDED':
                return {backgroundColor: '#82E0AA', color: '#9b59b6'};
            case 'CLINIC':
                return {backgroundColor: '#AEB6BF', color: '#9b59b6'};
            default:
                return {backgroundColor: '#E5E7E9', color: '#ffffff'};
        }
    };

    const handlePress = () => {
        if (isEditing && onEditRequest) {
            onEditRequest();
            return;
        }
        setIsOpen(!isOpen);
    };

    return (
        <Pressable onPress={handlePress} style={{zIndex: 10}} ref={bannerRef}>
            <View style={[styles.banner, getStatusColor(selectedOption)]}>
                {isEditing ? (
                    <Text style={styles.bannerText}>{selectedOption}</Text>
                ) : (
                    <Text style={styles.bannerText}>{sessionType}</Text>
                )}
                {isOpen && isEditing && !onEditRequest && (
                    <View style={styles.dropdownList}>
                        {renderOptions()}
                    </View>
                )}
            </View>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    banner: {
        paddingHorizontal: 10,
        paddingVertical: 5,
        borderRadius: 15,
        marginBottom: 8,
        width: 120,
        alignItems: 'center',
        marginRight: 10,
        zIndex: 10,
    },
    bannerText: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'white',
        zIndex: 2,
    },
    dropdownList: {
        marginTop: 2,
        backgroundColor: 'white',
        borderRadius: 8,
        top: 30,
        left: 0,
        minWidth: 120,
        position: 'absolute',
        zIndex: 10,
    },
});

export default SessionTypeBanner;
